import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "input", "text"]
  static values = {
    url: String,
    field: { type: String, default: "title" }
  }

  connect() {
    this.editing = false
    this.originalValue = this.textValue
  }

  get textValue() {
    return this.hasTextTarget ? this.textTarget.textContent.trim() : this.displayTarget.textContent.trim()
  }

  set textValue(value) {
    if (this.hasTextTarget) {
      this.textTarget.textContent = value
    } else {
      this.displayTarget.textContent = value
    }
  }

  edit() {
    if (this.editing) return

    this.editing = true
    this.originalValue = this.textValue

    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.value = this.originalValue
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  save() {
    const newValue = this.inputTarget.value.trim()

    if (newValue === this.originalValue || newValue === "") {
      this.cancel()
      return
    }

    this.submitUpdate(newValue)
  }

  cancel() {
    this.editing = false
    this.inputTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancel()
    }
  }

  async submitUpdate(newValue) {
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ chat: { [this.fieldValue]: newValue } })
      })

      if (response.ok) {
        this.textValue = newValue
        this.originalValue = newValue
        this.cancel()

        const html = await response.text()
        if (html) {
          Turbo.renderStreamMessage(html)
        }
      } else {
        this.cancel()
      }
    } catch (error) {
      console.error("Failed to update:", error)
      this.cancel()
    }
  }
}
